import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className", "hasError", "hasSuccess", "prefix", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import { useRef, useEffect } from 'react';
import CurrencyInput from 'react-currency-input-field';
import { customFormValidityMethod } from '@/config/general';
import { isValidForMax, isValidForMin } from '@/utils/validation';
import { utils as utilsCore } from '@industriousapps/excelkits-core';
import formStyles from '../styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  toNumericString
} = utilsCore;
const INPUT_PREFIX = '$';

const Currency = _ref => {
  let {
    className,
    hasError,
    hasSuccess,
    prefix = '',
    onChange = () => null
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const inputRef = useRef(null); // Determine if user aswer is valid
  // if require and any min/max requirements

  const validate = () => {
    if (!inputRef || !inputRef.current) return true;
    const inputEl = inputRef.current;
    const srcVal = (inputEl === null || inputEl === void 0 ? void 0 : inputEl.value) || '';
    const amount = parseFloat(toNumericString(srcVal || '0'));
    return inputEl.checkValidity() && // @ts-ignore
    isValidForMin(amount, props.min) && // @ts-ignore
    isValidForMax(amount, props.max);
  }; // Add custom validition method


  useEffect(() => {
    if (inputRef.current) {
      inputRef.current[customFormValidityMethod] = validate;
    } // Cleanup custom method


    return () => {
      // eslint-disable-next-line
      if (inputRef.current) delete inputRef.current[customFormValidityMethod];
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputRef.current, validate]);
  return /*#__PURE__*/_jsx(CurrencyInput, _objectSpread({
    ref: inputRef,
    prefix: prefix || INPUT_PREFIX,
    className: clsx(formStyles.input, hasError ? formStyles['input--hasError'] : '', hasSuccess ? formStyles['input--hasSuccess'] : ''),
    onValueChange: val => onChange(val || '0')
  }, props));
};

export default Currency;